/**
 * מצבי תוצאות מקבילות (RT + OW) לשימוש ב־FlightBookingFlowMockup + BookingFlowProvider.
 */
export function computeFlightBookingSearchGate({
  flightTripType,
  parallelRoundTripFlightSearchCompleted,
  roundTripFlightResults,
  outboundOneWayFlightResults,
  inboundOneWayFlightResults,
}) {
  const rtCount = roundTripFlightResults?.length ?? 0;
  const outboundCount = outboundOneWayFlightResults?.length ?? 0;
  const inboundCount = inboundOneWayFlightResults?.length ?? 0;

  const parallelOk =
    flightTripType === "RoundTrip" && !!parallelRoundTripFlightSearchCompleted;

  const needsSelfComposePickStep =
    parallelOk && rtCount === 0 && outboundCount > 0 && inboundCount > 0;

  const partialSelfCompose =
    parallelOk &&
    rtCount === 0 &&
    ((outboundCount > 0 && inboundCount === 0) ||
      (outboundCount === 0 && inboundCount > 0));

  /** יש הלוך OW בלבד (אין חזור) — ממשיכים בזרימה רגילה עם בחירת הלוך */
  const outboundOnlyNoReturn =
    parallelOk && rtCount === 0 && outboundCount > 0 && inboundCount === 0;

  /** הלוך+חזור מקבילי עם רשימות OW — אפשר להיכנס להרכבה גם כשיש גם עסקאות RT */
  const allowSelfComposeChoice =
    parallelOk &&
    outboundCount > 0 &&
    inboundCount > 0 &&
    !partialSelfCompose;

  return {
    rtCount,
    outboundCount,
    inboundCount,
    needsSelfComposePickStep,
    partialSelfCompose,
    outboundOnlyNoReturn,
    parallelOk,
    allowSelfComposeChoice,
  };
}
